// App.tsx
import React, { useState } from 'react';
import { Route, Routes, Navigate, HashRouter } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import LoginPage from './frontend/views/LoginPage';
import Dashboard from './frontend/views/dashboard';
import RecoverPassword from './frontend/views/RecoverPassword';
import { ApiImplementation } from './logic/infraestructure/api/apiImplementation';
import { ProtocoloService } from './logic/domain/services/protocoloService';
import { GetPersona } from './logic/aplication/getPersona';
import { Persona } from './logic/domain/entities/persona';
import glymTheme from './theme';
import './App.css';

function App() {
  const emptyPersona = new Persona(0,"Sin Apellido","Sin Nombre","Sin Email","Sin Tipo","Sin nroDoc","sin pass")
  const [token, setToken] = useState<string | null>(localStorage.getItem('token'));
  const [personaData, setPersonaData] = useState<Persona>(emptyPersona); // Agrega estado para los datos de la persona

  const handleLogin = async (response: { token: string }) => {
    setToken(response.token);
    localStorage.setItem('token', response.token);

    // Llamar a la API para obtener los datos de la persona
    const apiImplementation = new ApiImplementation();
    const protocoloService = new ProtocoloService(apiImplementation);
    const getPersona = new GetPersona(protocoloService);
    
    try {
      const persona = await getPersona.execute(response.token);
      setPersonaData(persona); // Almacena los datos de la persona en el estado
    } catch (error) {
      console.error('Error al obtener los datos de la persona:', error);
    }
  };

  const handleLogout = () => {
    setToken(null);
    setPersonaData(emptyPersona); // Limpiar los datos de la persona al cerrar sesión
    localStorage.removeItem('token');
    localStorage.removeItem('prestaciones');
    localStorage.removeItem('protocolos');
  };

  return (
    <ThemeProvider theme={glymTheme}>
      <CssBaseline />
      <HashRouter>
        <Routes>
          <Route 
            path="/login" 
            element={!token ? <LoginPage onLogin={handleLogin} /> : <Navigate to="/dashboard/listadoprotocolos" />} 
          />
          <Route 
            path="/recover-password" 
            element={<RecoverPassword />} 
          />
          <Route 
            path="/dashboard/*" 
            element={token ? <Dashboard user ={personaData || emptyPersona} onLogout={handleLogout} /> : <Navigate to="/login" />} 
          />
          <Route 
            path="*" 
            element={<Navigate to={token ? "/login" : "/dashboard"} />} 
          />
        </Routes>
      </HashRouter>
    </ThemeProvider>
  );
}

export default App;
